import { connect } from "react-redux"
import { Dispatch } from "redux"
import { getCurrentUser } from "../../../../../libs/get-current-user"
import { RootState, ReduxAction } from "../../../../../reducers"
import { ChatRoom } from "../../../../../rpcs/dist/ChatRoomRPC"
import { User } from "../../../../../rpcs/dist/UserRPC"
import { ActionDispatcher } from "../../../actiondispacher/action-dispacher"
import { ContentActionDispatcher } from "../../../actiondispacher/content-action-dispacher"
import { IEditorContent } from "../../../types"

export interface IContainerProps {
  chatRoom: ChatRoom | null
  currentUser: User | null
  uuid: IEditorContent["uuid"] | null
  actions: ActionDispatcher
  contentActions: ContentActionDispatcher
}

const mapStateToProps = ({
  pages,
  switchingUser,
  loginData,
}: RootState): Omit<IContainerProps, "actions" | "contentActions"> => ({
  chatRoom:
    pages.editor.fetchData.episode && pages.editor.fetchData.episode.chatRoom,
  uuid: pages.editor.currentEditingState.surveyModal,
  currentUser: getCurrentUser(loginData, switchingUser),
})

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
  contentActions: new ContentActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
